import React, { useCallback, useEffect, useRef, useState } from "react";

import axios from "../axios";
import ModalAlert from "../modal/modal_alert";

const Questions = ({ currentUser }) => {
  const [isModalOpen, setIsModalOpen] = useState(true);
  const [prefs, setPrefs] = useState([]);
  const [isSuccess, setIsSuccess] = useState(true);
  const modalAlertFirstQuestion = useRef(null);

  useEffect(
    () => {
      axios
        .get("/api/locations/pref_list")
        .then((res) => setPrefs(res.data.prefs));
    },
    [setPrefs]
  );

  const updateMyPref = useCallback((prefId) => {
    axios
      .patch("/api/user", { user: { pref_id_1: prefId } })
      .then(() => setIsSuccess(true))
      .catch(() => setIsSuccess(false))
      .finally(() => {
        setIsModalOpen(false);
        modalAlertFirstQuestion.current.openModal();
      });
  }, []);

  return (
    <React.Fragment>
      <div className={`modal-view ${isModalOpen ? "d-block" : "d-none"}`}>
        <div
          className={isModalOpen ? "modal-view-fade-in" : "modal-view-fade-out"}
        >
          <div className="modal-view-overAll">
            <div className="modal-view-overlay" />
            <div className="modal-view-large-dialog">
              <div className="modal-view-content">
                <div className="card bg-gray pt-3">
                  <h6 className="text-fw-bold text-center mb-3_5">
                    地域を選択してください
                  </h6>
                  <div className="card bg-white h-100">
                    <ul className="nav flex-column">
                      {prefs.map((pref) => (
                        <li
                          key={pref.id}
                          className="nav-item p-3 border-bottom"
                        >
                          <input
                            type="radio"
                            name="pref"
                            id={pref.id}
                            className="d-none checkbox__input checkbox__area"
                            defaultValue={pref.id}
                            onChange={(e) => updateMyPref(e.target.value)}
                            defaultChecked={
                              currentUser && pref.id === currentUser.pref_id_1
                            }
                          />
                          <label
                            className="d-flex justify-content-between align-items-center mb-0 position-relative"
                            htmlFor={pref.id}
                          >
                            <span className="p-0 line-height-2 pl-3 mb-0">
                              {pref.name}
                            </span>
                            <span className="checkbox__lg checkbox__noborder" />
                          </label>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ModalAlert
        ref={modalAlertFirstQuestion}
        title={isSuccess ? "登録完了" : "登録失敗"}
        content={
          isSuccess
            ? "地域を登録しました。"
            : "お時間をおいて再度設定してください。"
        }
        approveFunc={isSuccess ? () => location.reload() : () => {}}
      />
    </React.Fragment>
  );
};

export default Questions;
